import React from "react";
import {
    Tooltip,
    Typography,
} from "@material-ui/core";

const Counter = ({ value, label, noColor }) => {

    if (!value) return null;

    return (
        <Tooltip title={label || ""}>
            <div
                style={{
                    backgroundColor: noColor ? "var(--mainText)" : "var(--ownBlue)",
                    borderRadius: "50%",
                    height: 24,
                    width: 24,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                }}
            >
                <Typography style={{ color: noColor ? "var(--negativeText)" : "white", fontSize: 12, fontWeight: 500 }}>
                    {value > 9 ? "+9" : value}
                </Typography>
            </div>
        </Tooltip>
    );
}

export default Counter;